module.exports = __webpack_public_path__ + "static/img/2.70b00bf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/9/zh/2.png
// module id = HKd2
// module chunks = 0